import { getGroupList as fetchGroupList } from 'Api/categoryApi'
import { parseGroupOrder } from 'Parsers/categoryParser'

const state = {
  requesting: {
    groupList: false,
  },

  selected: {
    main: false,
    user: false,
    company: false,
    search: false,
    category: false,
    sales: false,
    shopping: false,
  },

  groupList: [],
}

const mutations = {
  request_start(state, type) {
    state.requesting[type] = true
  },
  request_success(state, type) {
    state.requesting[type] = false
  },
  request_failure(state, type) {
    state.requesting[type] = false
  },

  set_selected(state, payload) {
    state.selected = Object.assign(state.selected, payload)
  },

  set_group_list(state, groupList) {
    state.groupList = groupList
  }
}

const actions = {
  async getGroupList({ commit }) {
    commit('request_start', 'groupList')

    try {
      const { data } = await fetchGroupList()

      const groupOrder = parseGroupOrder(data)
      commit('set_group_list', groupOrder)

      commit('request_success', 'groupList')

      return data
    } catch (err) {
      commit('request_failure', 'groupList')

      throw err
    }
  },

  openMenu({ commit }, type) {
    let selected = Object.assign({}, state.selected)

    Object.keys(selected).forEach(key => selected[key] = false)
    selected[type] = true

    commit('set_selected', selected)
  },

  toggleMenu({ commit, state }, type) {
    let selected = Object.assign({}, state.selected)
    const newValue = !selected[type]

    Object.keys(selected).forEach(key => selected[key] = false)
    selected[type] = newValue

    commit('set_selected', selected)
  },

  closeMenu({ commit }, type) {
    commit('set_selected', {
      [type]: false
    })
  },

  closeAll({ commit }) {
    let selected = Object.assign({}, state.selected)
    Object.keys(selected).forEach(key => selected[key] = false)

    commit('set_selected', selected)
  }
}

export default {
  namespaced: true,

  state,
  actions,
  mutations
}